import { render, staticRenderFns } from "./NotificationsSettings.vue?vue&type=template&id=373c2c34&scoped=true&"
import script from "./NotificationsSettings.vue?vue&type=script&lang=js&"
export * from "./NotificationsSettings.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsSettings.vue?vue&type=style&index=0&id=373c2c34&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373c2c34",
  null
  
)

export default component.exports